module.exports = __webpack_public_path__ + "img/luza.fa0293b9.png";